<template>
    <div id="app">
       <app-iocard></app-iocard>
    </div>
</template>

<script>

    import iocard from './views/ioCard.vue'

    export default {
        name: 'app',
        components: {
            'app-iocard': iocard,
        },
    }
</script>

<style scoped>

    @import url('https://fonts.googleapis.com/css?family=Montserrat');

    #app {
        font-family: 'Montserrat', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        line-height: 1.5;
        text-align: center;
    }
</style>
